import { useRef } from 'react';
import { parseGcsExpiryMs } from '../utils/parseGcsExpiry';
type PropsT = {
  src: string;
  srcExpirationDuration: number | null;
};

// Ideally, we would receive the srcIssuedAt timestamp directly from the backend.
// Since that's not available, we approximate it by recording the first time we see a new src.
// This means the computed expiration time may be slightly inaccurate due to network delays
// or if the src is cached upstream. If the src is a GCS URL with explicit expiry parameters,
// we can extract the exact expiration time from the URL. Otherwise, we fall back to using
// the srcExpirationDuration prop (relative to when the src was first seen).
export function useComputedExpiryTime({
  src,
  srcExpirationDuration
}: PropsT) {
  const issueAtMsRef = useRef<number | null>(null);
  const prevSrcRef = useRef<string | null>(null);
  const gcsExpiryMs = parseGcsExpiryMs(src);
  if (gcsExpiryMs) {
    return gcsExpiryMs;
  }

  // Fallback to manually determining expiration time
  if (src && prevSrcRef.current !== src) {
    prevSrcRef.current = src;
    // eslint-disable-next-line react-hooks/purity
    issueAtMsRef.current = Date.now();
  }
  if (!src) {
    return null;
  }
  if (typeof srcExpirationDuration === 'number' && srcExpirationDuration > 0) {
    const baseIssuedAtMs = issueAtMsRef.current;
    if (baseIssuedAtMs) {
      return baseIssuedAtMs + srcExpirationDuration;
    }
  }
  return null;
}